(function() {
    angular
        .module("noticesModule")
        .config(noticesRouter)

    noticesRouter.$inject = [
        "$stateProvider",
        "$urlRouterProvider",
        "$locationProvider"
    ]

    function noticesRouter(
        $stateProvider,
        $urlRouterProvider,
        $locationProvider
    ){
        $stateProvider
        .state("notices", {
            url: "/notices",
            templateUrl: "app/components/notices/notices.view.html",
            controller : "NoticesController"
        })
        // .state("alert-details-message-board", {
        //     url: "/alert-details/id/:alert_id/message-board/:component_id",
        //     templateUrl: "app/components/alerts/alert-details-message-board.view.html",
        //     controller : "AlertDetailsMessageBoardController"
        // })
        // .state("alert-details-tracker", {
        //     url: "/alert-details/id/:alert_id/tracker/:component_id",
        //     templateUrl: "app/components/alerts/alert-details-tracker.view.html",
        //     controller : "AlertDetailsTrackerController"
        // })

        $urlRouterProvider.otherwise("/")

        $locationProvider.html5Mode(true)
    }
})()
